import React from "react";
import type { FC } from "react";
import { useState } from "react";
import UtilityPanel from "../layout/UtilityPanel";
import CorePanelFooter from "../layout/CorePanelFooter";
import CoreLayout from "../layout/CoreLayout";
import { useModal } from "../../hooks/useModal";
import Button from "../form/Button";
import { useNavigate } from "react-router-dom";
import { useAppStore } from "../../store/appStore";
import { submitMfaMethod } from "../../api/api";
import { withErrorBoundary } from "../components/withErrorBoundary";

interface Props {
	getSessionId: () => string | null;
	cancelSession: () => void;
}

const MfaMethod: FC<Props> = (props) => {
	const { setForceCheckSessionStatus, maskedPhoneNumber, maskedEmailAddress } = useAppStore();
	const { showModal } = useModal();
	const navigate = useNavigate();

	function onNext(mfaMethodType: "SMS" | "EMAIL") {
		const sessionId = props.getSessionId();
		if (sessionId != null) {
			submitMfaMethod(sessionId, mfaMethodType);
			setForceCheckSessionStatus(true);
		}
	}

	return (
		<CoreLayout>
			<UtilityPanel title="Choose your PG&E authentication method">
				<div className="flex flex-col justify-start items-start gap-4">
					<Button onClick={() => onNext("SMS")} type="secondary" subType="outline" className="w-full">
						SMS Text Message {maskedPhoneNumber ? `to ${maskedPhoneNumber}` : ""}
					</Button>
					<Button onClick={() => onNext("EMAIL")} type="secondary" subType="outline" className="w-full">
						Email {maskedEmailAddress ? `to ${maskedEmailAddress}` : ""}
					</Button>
				</div>
			</UtilityPanel>
			<CorePanelFooter>
				<Button
					onClick={() =>
						showModal(
							"cancel",
							"Are you sure you want to cancel?",
							"Cancelling will end the authorization process.",
							props.cancelSession,
						)
					}
					type="primary"
					subType="outline"
				>
					Cancel
				</Button>
			</CorePanelFooter>
		</CoreLayout>
	);
};

export default withErrorBoundary(MfaMethod);
